import React, {useEffect, useState} from "react";
import Dropdown from "../../../primer/Dropdown";
import { excelOptions } from "../../../../_data/settings/doc-types";
import { useDispatch, useSelector } from "react-redux";
import {checkPermission, fastTable, isEmpty} from "../../../../_helpers/commonFunctions";
import {
    exportAutocomplete, exportAutoSelectAll,
    setExport, setExportFields, setTooltipExport, setValuesChecksExport, setValuesExport
} from "../../../../_reducers/settingsSlice";
import axios from "axios";
import {toast} from "react-toastify";
import Checkbox from "../../../common/CheckBox";
import ModalInstructions from "../../../primer/POPUP-COMPONENTS/Instructions";
import {Row} from "react-bootstrap";
import {banksDummyData} from "../../../../_data/dummy_banks";
import {setUpdateInnerTab} from "../../../../_reducers/activitySlice";
import DateBox from "../../../primer/DateBox";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import moment from "moment";
import ReportsTemplate from "../../../common/ReportsTemplate";
import JoyrideTour from "../../../primer/JoyrideTour/JoyrideTour";
import {useTranslation} from "../../../../hooks/useTranslation";
import Button from "react-bootstrap/Button";

export const SettingsOfExport = () => {
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loader, setLoader] = useState(false);
    const {t} = useTranslation();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const exportSectionOptions = [
        {value: "Products", label: t("SettingsImportExport.sectionProducts")},
        {value: "Product Movements", label: t("SettingsImportExport.sectionProductMovements")},
        {value: "Clients", label: t("SettingsImportExport.sectionClients")},
        {value: "Client Movements", label: t("SettingsImportExport.sectionClientMovements")},
        {value: "Supplier Movements", label: t("SettingsImportExport.sectionSupplierMovements")},
        {value: "Sales", label: t("SettingsImportExport.sectionSales")},
        {value: "Client Payments", label: t("SettingsImportExport.sectionClientPayments")},
        {value: "POS", label: t("SettingsImportExport.sectionPOS")},
        {value: "Cash Registers", label: t("SettingsImportExport.sectionCashRegisters")},
        {value: "Bank Accounts", label: t("SettingsImportExport.sectionBankAccounts")},
        {value: "Suppliers", label: t("SettingsImportExport.sectionSuppliers")},
        //{ value: "Buys", label: "Buys" },
        //{ value: "Supplier Payments", label: "Supplier Payments" },
        {value: "Employees", label: t("SettingsImportExport.sectionEmployees")},
        {value: "Accounting Accounts", label: t("SettingsImportExport.sectionAccountingAccounts")},
        {value: "Accounting Records", label: t("SettingsImportExport.sectionAccountingRecords")},
        {value: "Fixed Assets", label: t("SettingsImportExport.sectionFixedAssets")},
        {value: "Fixed Asset Movements", label: t("SettingsImportExport.sectionFixedAssetMovements")},
    ]
    const fieldsToCheck = [
        "myDataIncExp",
        "myDataRowType",
        "myDataRowCategory",
        "myDataRowInvoiceType",
        "contactAcceptNotifications",
        "contactNotes",
        "contactEmail",
        "contactLandline",
        "contactPhone2",
        "contactPhone",
        "contactName",
        "installationCustomVat",
        "installationVatReason",
        "installationVatCategory",
        "installationPostalCode",
        "installationCity",
        "installationDOY",
        "installationAddress",
        "installationNo",
        "chequeFirstDate",
        "chequeLastDate",
        "myDataUID",
        "myDataMark",
        "extraDataTaxType",
        "extraDataTaxCode",
        "extraDataTaxAmount",
        "isTaxLine",
        "productExtraTaxType",
        "productExtraTaxCode",
        "productExtraTaxAmount",
        "deliveryLocationAddress",
        "deliveryLocationCity",
        "deliveryLocationCountry",
        "deliveryLocationPostalCode",
    ];
    const dispatch = useDispatch();
    const handleOnChange = (e, type = "default", ddname = "", index) => {
        //let name = "";
        let value = "";
        if(type === "dd") {
            //name = ddname;
            value = e.value;
        } else {
            value = e.target.value;
        }
        if (ddname === "section") {
            dispatch(setExport(value));
            loadTooltips();
        } else {
            if (type === "dd") {
                const isUnique = SETTINGS.export.fields.every(
                    (obj) => obj["column"] === "" || obj["column"] !== value
                );
                if (!isUnique) {
                    toast.error(t("SettingsImportExport.toasts.alreadySelectedColumn"));
                } else {
                    dispatch(setValuesExport({ type, value, index }));
                }
            } else if (type === "cb" || type === "checkAll") { // Checkbox
                if((ddname === "Delivery Location Address" || ddname === "Delivery Location City"
                        || ddname === "Delivery Location Country" || ddname === "Delivery Location Postal Code")
                    && SETTINGS.export.fields.filter((el) => el.fieldKey === "deliveryLocation")[0].checkBox === false
                    && SETTINGS.export.section === "Sales") {
                    toast.error(t("SettingsImportExport.toasts.deliveryLocationCheck"));
                } else if (ddname === "My Data Auth Code"
                    && SETTINGS.export.fields.filter((el) => el.fieldKey === "myDataMark")[0].checkBox === false
                    && SETTINGS.export.section === "Sales") {
                    toast.error(t("SettingsImportExport.toasts.myDataCheck"));
                } else {
                    dispatch(setValuesExport({type, value, index}));
                }
            }
        }
    }

    useEffect(() => {
        loadTooltips();
    }, [SETTINGS.export.section])

    const startExport = () => {
        setLoader(true);
        let bug = false;
        let count = 0;
        SETTINGS.export.fields.forEach((element) => {
            if (element.checkBox) {
                count++;
            }
        })
        if(count > 0) {
            SETTINGS.export.fields.forEach((element) => {
                if (element.checkBox) {
                    if (element.column === null) {
                        toast.error(t("SettingsImportExport.toasts.pleaseSelectColumnFor") + " "
                            + t("SettingsImportExport." + SETTINGS.export.section + "." + element["fieldKey"]));
                        bug = true;
                    }
                }
            });
        } else {
            bug = true;
            toast.error("Please select at least one column for export.");
        }
        setLoader(false);

        if(!bug) dispatch(setUpdateInnerTab(2));
    }
    const loadTooltips = () => {
        if(SETTINGS.export.section === "Products") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/productsToolTipCategories`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "category", title: "Κατηγορίες Ειδών", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
        } else if(SETTINGS.export.section === "Client Payments") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipPaymentTypes`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "paymentType", title: "Τρόποι Πληρωμής", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "installation", title: "Εγκαταστάσεις", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltipExport({key: "documentTypeName", title: "Τύποι Παραστατικών Εισπράξεων", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
        } else if (SETTINGS.export.section === "Client Movements") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltipExport({
                    key: "installationMasterID",
                    title: "Εγκαταστάσεις",
                    content: response.data.message
                }))
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientMovementsToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltipExport({
                    key: "documentTypeName",
                    title: "Τύποι Παραστατικών Κινήσεων",
                    content: response.data.message
                }));
            }).catch((error) => {
                console.log(error);
            });
        } else if (SETTINGS.export.section === "Supplier Movements") {
                axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                    headers: {"Content-Type": "application/json"},
                }).then((response) => {
                    dispatch(setTooltipExport({
                        key: "installationMasterID",
                        title: "Εγκαταστάσεις",
                        content: response.data.message
                    }))
                }).catch((error) => {
                    console.log(error);
                });
                axios.post(process.env.REACT_APP_API_URL2 + `/import/supplierMovementsToolTipDocumentTypes`, {company: company.id}, {
                    headers: {"Content-Type": "application/json"},
                }).then((response) => {
                    dispatch(setTooltipExport({
                        key: "documentTypeName",
                        title: "Τύποι Παραστατικών Κινήσεων",
                        content: response.data.message
                    }));
                }).catch((error) => {
                    console.log(error);
                });
        } else if (SETTINGS.export.section === "Sales") {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "installationMasterID", title: "Εγκαταστάσεις", content : response.data.message}))
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipDocumentTypes`, {company: company.id}, {
                headers: {"Content-Type": "application/json"},
            }).then((response) => {
                dispatch(setTooltipExport({key: "documentTypeName", title: "Τύποι Παραστατικών Πωλήσεων", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipPaymentTypes`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "paymentType", title: "Τρόποι Πληρωμής", content: "Πρέπει να εκχωρήσετε τον αριθμό<br/><br/>" + response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipCarNumbers`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "carNumber", title: "Αριθμοί αυτοκινήτων", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
            axios.post(process.env.REACT_APP_API_URL2 + `/import/salesToolTipSendingGoods`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "wayOfSendingGoods", title: "Τρόποι αποστολής εμπορευμάτων", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            });
        } else if (SETTINGS.export.section === "Bank Accounts") {
            let prepContent = "<table className='table-bordered' style='text-align: center; margin-right: auto; margin-left: auto;'><tr><th>Swift</th><th>Όνομα Τράπεζας</th></tr>";
            for(let bank in banksDummyData) {
                prepContent += "<tr>";
                prepContent += "<td>" + banksDummyData[bank].swift + "</td>"
                prepContent += "<td>" + banksDummyData[bank].name + "</td>"
                prepContent += "</tr>";
            }
            prepContent += "</table>";
            dispatch(setTooltipExport({key: "bankSwift", title: "Swift Τραπεζών", content: prepContent}))
        } else if (SETTINGS.export.section === "Accounting Accounts") {
            axios.post(process.env.REACT_APP_API_URL2 + "/import/accountingAccountsSettings", {company: company.id}, {
                headers: {"Content-Type": "application/json"}
            }).then((response) => {
                dispatch(setTooltipExport({key: "category", title: "Πρότυπα Λογαριασμών", content: response.data.message}));
            }).catch((error) => {
                console.log(error);
            })
        } else if (["Fixed Assets", "Fixed Asset Movements"].includes(SETTINGS.export.section)) {
            axios.post(process.env.REACT_APP_API_URL2 + `/import/clientPaymentsToolTipInstallations`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                dispatch(setTooltipExport({key: "installation", title: "Εγκαταστάσεις", content : response.data.message}))
            }).catch((error) => {
                console.log(error);
            });
        } else if (SETTINGS.export.section === "Accounting Records") {
            axios.post(`${process.env.REACT_APP_API_URL2}/import/accountingRecordsTooltips`, {company: company.id}, {
                headers: { "Content-Type": "application/json" },
            }).then((response) => {
                if (response.data.status === "200") {
                    dispatch(setTooltipExport({
                        key: "installation",
                        title: "Εγκαταστάσεις",
                        content: fastTable("installations", ["Κωδικός", "Εγκατάσταση"], response.data.installations),
                    }));
                    dispatch(setTooltipExport({
                        key: "categoryName",
                        title: "Λογιστικές Κατηγορίες",
                        content: fastTable("categoryNames", ["Όνομα Κατηγορίας"], response.data.accountingCategories),
                    }));
                    dispatch(setTooltipExport({
                        key: "subCategoryName",
                        title: "Λογιστικές Υποκατηγορίες",
                        content: fastTable("subCatogories", ["Όνομα Υποκατηγορίας"], response.data.accountingSubCategories),
                    }));
                    dispatch(setTooltipExport({
                        key: "documentTypeName",
                        title: "Γενικά Παραστατικά Λογιστικής",
                        content: fastTable("documentTypeNames", ["Όνομα Γενικού Παραστατικού"], response.data.accountingDocumentTypes),
                    }));
                    dispatch(setTooltipExport({
                        key: "paymentTypeName",
                        title: "Τρόποι Πληρωμής",
                        content: fastTable("paymentTypeNames", ["Όνομα τρόπου πληρωμής"], response.data.paymentTypes),
                    }));
                }
            }).catch((error) => {
                console.log(error);
            });
        }
    }
    const handleDateFrom = (data) => {
        dispatch(setExport({...SETTINGS.export, date_from: moment(data).isValid() ? data : ""}));
    }
    const handleDateTo = (data) => {
        dispatch(setExport({...SETTINGS.export, date_to: moment(data).isValid() ? data : ""}));
    }

    const autocompleteCols = () => {
        dispatch(exportAutocomplete());
    }

    const autoSelectAll = () => {
        dispatch(exportAutoSelectAll());
    }

    const handleFinalFields = (requestFields) => {
        const clonedFields = structuredClone(SETTINGS.export.fields.map(({ tooltip, ...rest }) => rest));
        const map = new Map(requestFields.map((obj) => [obj["fieldKey"], obj]));
        return clonedFields.map((obj) => {
            if (map.has(obj["fieldKey"])) {
                const updates = map.get(obj["fieldKey"]);
                return {
                    ...obj,
                    column: updates.column,
                    checkBox: updates.checkBox,
                };
            }
            return obj;
        });
    }

    const [startTour1, setStartTour1] = useState(false);
    const [startTour2, setStartTour2] = useState(false);

    const tour1Steps = [{
        target: '.sectionDropdown',
        content: t("SettingsImportExport.joyride.section"),
        disableBeacon: true,
        disableScrolling: true,
        disableScrollParentFix: true
    }]

    const tour2Steps = [
        {
            target: '.forJoyReqField',
            content: t("SettingsImportExport.joyride.fields"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyReqColumn',
            content: t("SettingsImportExport.joyride.columnsExport"),
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyTooltip',
            content: t("SettingsImportExport.joyride.tooltipsExport"),
            disableScrolling: true,
            disableScrollParentFix: true
        },
    ]

    return (
        <>
            <div className="export-settings">
                {SETTINGS.export.section && (
                    <ReportsTemplate templateType={`export_${SETTINGS.export.section}`}
                                     requestData={SETTINGS.export.fields.map((o) => ({...o, tooltip: null}))}
                                     setRequestData={(data) => dispatch(setExportFields(handleFinalFields(data)))}
                                     header="Import/Export"
                                     templateDisplayName={SETTINGS.export.displayTemplateName}
                                     fetchReport={() => {}}
                    />
                )}
                {!SETTINGS.export.section && (
                    <React.Fragment>
                        <button className="btn btn-primary float-right joyHelpButton" onClick={() => setStartTour1(true)}>{t("SettingsImportExport.help")}</button>
                        <JoyrideTour
                            steps={tour1Steps}
                            startTour={startTour1}
                            setStartTour={setStartTour1}
                        />
                    </React.Fragment>
                )}
                <div className="row">
                    <div className="col-12 col-md-4">
                        <Dropdown
                            label={t("SettingsImportExport.section")}
                            options={exportSectionOptions}
                            value={exportSectionOptions.filter((el) => el.value === SETTINGS.export.section)}
                            classes="sectionDropdown"
                            name="section"
                            enabledValue={true}
                            onChange={(e) => handleOnChange(e, "dd", "section")}
                        />
                    </div>
                    {SETTINGS.export.section && ['Product Movements', 'Client Movements', 'Supplier Movements', 'Sales', 'Client Payments', "Fixed Asset Movements", "Accounting Records"].includes(SETTINGS.export.section) && (
                        <div className={"d-flex align-items-center justify-content-md-between col-md-8"}>
                            <div className="col-12 col-md-3">
                                <DateHelper
                                    dateFromAndToFunction={(from, to) => dispatch(setExport({...SETTINGS.export, date_from: moment(from, "DD/MM/YYYY").toDate(), date_to: moment(to, "DD/MM/YYYY").toDate()}))}
                                />
                            </div>
                            <div className="col-12 col-md-4">
                                <DateBox
                                    label={"Από Ημερομηνία"}
                                    name={"date_from"}
                                    selected={!isEmpty(SETTINGS.export.date_from) ? SETTINGS.export.date_from : ""}
                                    onChange={(e) => handleDateFrom(e)}
                                    disabled={false}
                                    allowOtherYears={true}
                                />
                            </div>
                            <div className="col-12 col-md-4">
                                <DateBox
                                    label={"Έως Ημερομηνία"}
                                    name={"date_to"}
                                    selected={!isEmpty(SETTINGS.export.date_to) ? SETTINGS.export.date_to : ""}
                                    onChange={(e) => handleDateTo(e)}
                                    disabled={false}
                                    allowOtherYears={true}
                                />
                            </div>
                        </div>
                    )}
                </div>
                {SETTINGS.export.section !== "" && (
                    <>
                        <hr />
                        <div className={"float-end"}>
                            <button className="btn btn-primary mr-2 joyHelpButton" onClick={() => setStartTour2(true)}>{t("SettingsImportExport.help")}</button>
                            <JoyrideTour
                                steps={tour2Steps}
                                startTour={startTour2}
                                setStartTour={setStartTour2}
                            />
                            <button className={"btn btn-primary"} onClick={() => autocompleteCols()}>
                                {t("SettingsImportExport.autocomplete")}
                            </button>
                            <br/>
                            <Button onClick={() => autoSelectAll()} className={"mt-2"}>
                                Επιλογή όλων
                            </Button>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.fieldName")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.excelColumn")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.fieldName")}</strong>
                                </label>
                            </div>
                            <div className="col-12 col-md-3">
                                <label className="w-100">
                                    <strong>{t("SettingsImportExport.excelColumn")}</strong>
                                </label>
                            </div>
                            <div className="row">
                                {SETTINGS.export.fields.map((field, i) => {
                                    return (
                                        <>
                                            {SETTINGS.export.section === "Sales" && field.fieldKey === "documentTypeName" &&
                                                <>
                                                    <div className="text-muted">{t("SettingsImportExport.Sales.mutedBasicData")}</div>
                                                </>
                                            }
                                            {SETTINGS.export.section === "Sales" && field.fieldKey === "productName" &&
                                                <>
                                                    <hr/>
                                                    <div className="text-muted">{t("SettingsImportExport.Sales.mutedBasicDataLine")}</div>
                                                </>
                                            }
                                            {SETTINGS.export.section === "Sales" && field.fieldKey === "myDataUID" &&
                                                <>
                                                    <hr/>
                                                    <div className="text-muted">{t("SettingsImportExport.Sales.mutedMyData")}</div>
                                                </>
                                            }
                                            {SETTINGS.export.section === "Sales" && field.fieldKey === "extraDataTaxType" &&
                                                <>
                                                    <hr/>
                                                    <div className="text-muted">{t("SettingsImportExport.Sales.mutedExtraData")}</div>
                                                </>
                                            }
                                            {SETTINGS.export.section === "Accounting Accounts" && field.fieldKey === "fee" &&
                                                <>
                                                    <hr/>
                                                    <div className="text-muted">{t("SettingsImportExport.Accounting Accounts.mutedCaseTax")}</div>
                                                </>
                                            }
                                            <div className="col-12 col-md-3 forJoyReqField">
                                                <Checkbox
                                                    text={t("SettingsImportExport." + SETTINGS.export.section + "." + field["fieldKey"])}
                                                    //required={field["required"]}
                                                    checked={field["checkBox"]}
                                                    defaultValue={field["checkBox"]}
                                                    value={field["checkBox"]}
                                                    //disabled={field["disabled"]}
                                                    className="mb-1 mr-2 centered-checkbox"
                                                    onChange={(e) => {
                                                        if(fieldsToCheck.includes(field["fieldKey"])) {
                                                            handleOnChange(e, "checkAll", field["fieldName"], i);
                                                        } else {
                                                            handleOnChange(e, "cb", field["fieldName"], i);
                                                        }
                                                    }
                                                    }
                                                />
                                            </div>
                                            <div className="col-12 col-md-3">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                    <div className="col-md-8 forJoyReqColumn">
                                                        <Dropdown
                                                            options={excelOptions.filter((el) => el.value === "" ? el : SETTINGS.export.fields.every((obj) => obj.column !== el.value))}
                                                            disabled={!field["checkBox"]}
                                                            value={excelOptions.find((option) => {
                                                                return option.value === field["column"];
                                                            })}
                                                            onChange={(e) =>
                                                                handleOnChange(e, "dd", field["fieldName"], i)
                                                            }
                                                            enabledValue={true}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        {field["tooltip"] && (
                                                            <div className="forJoyTooltip" style={{width: '35%'}}>
                                                                <ModalInstructions data={field["tooltip"]} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                )}
                <hr />
                <div className="row">
                    {SETTINGS.export.section !== "" && checkPermission("settings-importexport/export-read", permissionsData) && (
                        <div className="col-12 ml-auto mb-3">
                            <button
                                type="button"
                                className="btn btn-primary float-right"
                                onClick={() => startExport()}
                                >
                                {t("SettingsImportExport.startExport")}
                                <span> </span>
                                {loader && (
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                )}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

const SettingsExport = () => {
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const dispatch = useDispatch();
    const [response, setResponse] = useState(null);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const {t} = useTranslation();
    const [templateOptions, setTemplateOptions] = useState([]);
    const apiURL2 = process.env.REACT_APP_API_URL2;

    useEffect(() => {
        if (!SETTINGS.export.section) {
            toast.error(t("SettingsImportExport.toasts.selectionEmpty"));
            dispatch(setUpdateInnerTab(1));
        }
        if (SETTINGS.export.section) {
            let willReturn = false;
            SETTINGS.export.fields.forEach((element) => {
                if (element.checkBox) {
                    if (isEmpty(element.column)) {
                        willReturn = true;
                    }
                }
            });
            if(willReturn) {
                toast.error(t("SettingsImportExport.toasts.someExcelColumnsAreEmpty"));
                dispatch(setUpdateInnerTab(1));
            }
        }
    }, [])

    const backtoPrevious = () => {
        dispatch(setUpdateInnerTab(1));
    }

    const fetchTemplates = () => {
        const data = {company: company.id, type: `export_${SETTINGS.export.section}`};
        axios.post(apiURL2 + `/category/list-product-template`, data, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                setTemplateOptions(res.data.data);
            } else {
                toast.error(res.data.errors);
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const postTemplate = async (data) => {
        await axios.post(apiURL2 + `/category/add-product-template`, data, {
            headers: {"Content-Type": "application/json"},
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                toast.success("New autogenerated template added.");
            } else {
                toast.error(res.data.error);
            }
        }).catch((error) => {
            if (error && error.response && error.response.data && error.response.data.errors) {
                toast.error(error.response.data.errors);
            } else {
                console.log("Unable to add template.");
            }
        })
    }

    const deleteTemplate = async (data) => {
        const deleteRequest = {id: data._id, isActive: "delete", deleted: true, deleted_at: new Date()};
        await axios.put(apiURL2 + `/category/update-product-template`, deleteRequest, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            if (res.data && res.data.status === "200") {
                console.log("Template deleted.");
            } else {
                toast.error(res.data.error);
            }
        }).catch((error) => {
            toast.error(error + " Update Template");
        })
    }

    const exportButtonClicked = async () => {
        const filteredArray = SETTINGS.export.fields.filter(
            (obj) => obj.checkBox
        );
        const cMap = filteredArray.reduce((acc, cur) => {
            acc[cur.fieldKey] = cur.column.toString();
            return acc;
        }, {});
        const tMap = filteredArray.reduce((acc, cur) => {
            acc[cur.column] = t(`SettingsImportExport.${SETTINGS.export.section}.${cur.fieldKey}`);
            return acc;
        }, {});

        let endpoint = "";
        if (SETTINGS.export.section === "Products") {
            endpoint = "products";
        } else if (SETTINGS.export.section === "Clients") {
            endpoint = "clients";
        } else if (SETTINGS.export.section === "Client Payments") {
            endpoint = "clientPayments";
        } else if (SETTINGS.export.section === "Client Movements") {
            endpoint = "clientMovements";
        } else if (SETTINGS.export.section === "Supplier Movements") {
            endpoint = "supplierMovements";
        } else if (SETTINGS.export.section === "Sales") {
            endpoint = "sales";
        } else if (SETTINGS.export.section === "POS") {
            endpoint = "pos";
        } else if (SETTINGS.export.section === "Cash Registers") {
            endpoint = "cashRegisters";
        } else if (SETTINGS.export.section === "Bank Accounts") {
            endpoint = "bankAccounts";
        } else if (SETTINGS.export.section === "Suppliers") {
            endpoint = "suppliers";
        } else if (SETTINGS.export.section === "Accounting Accounts") {
            endpoint = "accountingAccounts";
        } else if (SETTINGS.export.section === "Product Movements") {
            endpoint = "productMovements";
        } else if (SETTINGS.export.section === "Fixed Assets") {
            endpoint = "fixedAssets";
        } else if (SETTINGS.export.section === "Fixed Asset Movements") {
            endpoint = "fixedAssetMovements";
        } else if (SETTINGS.export.section === "Accounting Records") {
            endpoint = "accountingRecords";
        } else if (SETTINGS.export.section === "Employees") {
            endpoint = "employees";
        }
        const response = await axios.post(process.env.REACT_APP_API_URL2 + `/export/${endpoint}Check`, {company: company.id, date_from: SETTINGS.export.date_from, date_to: SETTINGS.export.date_to}, {
            headers: { "Content-Type": "application/json" },
        }).catch((error) => {
            toast.error(error);
            console.log(error);
        });
        if (response?.data?.status === "400") {
            return toast.error(response.data.message);
        }
        setResponse(response);
        axios.post(process.env.REACT_APP_API_URL2 + `/export/${endpoint}`, {company: company.id, date_from: SETTINGS.export.date_from, date_to: SETTINGS.export.date_to, columnMapping: JSON.stringify(cMap), titleMapping: JSON.stringify(tMap), textInstead: SETTINGS.export.textInstead}, {
            headers: { "Content-Type": "application/json" },
            responseType: 'blob',
        }).then(async (response) => {
            let url = window.URL.createObjectURL(new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));
            let a = document.createElement('a');
            a.href = url;
            a.download = `${SETTINGS.export.section}.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            if (response.status === 200) {
                if (templateOptions.length === 0) return;
                if (String(SETTINGS.export.displayTemplateName).length > 0) return;
                const autoGeneratedTemplates = templateOptions.filter(item => item.autoGenerated);

                if (autoGeneratedTemplates.length > 3) {
                    const oldest = autoGeneratedTemplates.sort(
                        (a, b) => new Date(a.created_at) - new Date(b.created_at)
                    )[0];
                    if (oldest) {
                        await deleteTemplate(oldest);
                    }
                }

                const tempData = SETTINGS.export.fields.filter((field) => field.checkBox === true);
                const postRequestData = tempData.map(({ tooltip, ...rest }) => rest);
                const postTemplateData = {
                    company: company.id,
                    name: `Import/export ${moment().format("DD/MM/YYYY HH:mm")}`,
                    type: `export_${SETTINGS.export.section}`,
                    isActive: "active",
                    autoGenerated: true,
                    templateData: JSON.stringify(postRequestData),
                };

                if (postTemplateData && Object.keys(postTemplateData).length > 0) {
                    await postTemplate(postTemplateData);
                } else {
                    toast.error("Template data not found.");
                }
                fetchTemplates();
            }
        }).catch((error) => {
            toast.error(error);
            console.log(error);
        });
    }
    const handleOnChange = (e, type = "default", tname) => {
        let name = "";
        let value = "";

        if(type === "cb") {
            if(tname === "textInstead") {
                value = !SETTINGS.export.textInstead;
                name = e.target.name;
            }
            name = tname;
            dispatch(setValuesChecksExport({ type, name, value }));
        }
    }

    useEffect(() => {
        fetchTemplates();
    }, []);

    const [startTour3, setStartTour3] = useState(false);

    const tour3Steps = [
        {
            target: '.forJoyCB',
            content: t("SettingsImportExport.joyride.textInstead"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyExport',
            content: t("SettingsImportExport.joyride.exportButton"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        },
        {
            target: '.forJoyBack',
            content: t("SettingsImportExport.joyride.backButton"),
            disableBeacon: true,
            disableScrolling: true,
            disableScrollParentFix: true
        }
    ]

    return (
        <>
            <button className="btn btn-primary float-right joyHelpButton" onClick={() => setStartTour3(true)}>{t("SettingsImportExport.help")}</button>
            <JoyrideTour
                steps={tour3Steps}
                startTour={startTour3}
                setStartTour={setStartTour3}
            />
            <Row>
                <div className="col-md-3">
                    <Checkbox
                        text={t("SettingsImportExport.textInstead")}
                        value={SETTINGS.export.textInstead}
                        defaultValue={SETTINGS.export.textInstead}
                        className="mb-1 mr-2 centered-checkbox forJoyCB"
                        onChange={(e) => handleOnChange(e, "cb", "textInstead")}
                    />
                </div>
            </Row>
            <p className="text-danger">{t("SettingsImportExport.textOnlyDanger")}</p>
            <button type="button" className="btn btn-primary mr-3 mb-3 forJoyBack" onClick={() => backtoPrevious()}>{t("SettingsImportExport.back")}</button>
            {checkPermission("settings-importexport/export-read", permissionsData) &&
                <button type="button" className="btn btn-primary mb-3 forJoyExport" onClick={() => exportButtonClicked()}>{t("SettingsImportExport.export")}</button>
            }
            <div className="row">
                <div className="mb-2 col-12">
                    <p>Console</p>
                    <div className="bg-light w-100 border p-3">
                        {response && response.data.status === "200" &&
                            <p className="text-success">{response.data.count} {response.data.recordName} exported successfully. Sending XLSX...</p>
                        }
                        {response && response.data.status !== "200" &&
                            <p className="text-danger">Connection refused.</p>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default SettingsExport